import * as React from 'react';
import { StyleSheetManager } from 'styled-components';
import { CacheProvider } from '@emotion/react';
import { createEmotionCache as createCache } from '@mui/material-nextjs/v15-pagesRouter';
import { prefixer } from 'stylis';
import rtlPlugin from '@mui/stylis-plugin-rtl';
import GlobalStyles from '@mui/material/GlobalStyles';
import { ThemeOptionsContext } from 'docs/src/modules/components/ThemeContext';
import globalSelector from './globalSelector';

// Cache for the rtl version of the styles
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var cacheRtl = createCache({
  key: 'rtl',
  prepend: true,
  enableCssLayer: true,
  stylisPlugins: [prefixer, rtlPlugin, globalSelector]
});
export default function StyledEngineProvider(props) {
  var children = props.children,
    cacheLtr = props.cacheLtr;
  var _React$useContext = React.useContext(ThemeOptionsContext),
    direction = _React$useContext.direction;
  var rtl = direction === 'rtl';
  var emotionCache = direction === 'rtl' ? cacheRtl : cacheLtr;
  return /*#__PURE__*/_jsx(StyleSheetManager, {
    stylisPlugins: rtl ? [rtlPlugin] : [],
    children: /*#__PURE__*/_jsxs(CacheProvider, {
      value: emotionCache,
      children: [/*#__PURE__*/_jsx(GlobalStyles, {
        styles: "@layer theme, docsearch, mui, utilities;"
      }), children]
    })
  });
}
false ? void 0 : void 0;